import * as React from 'react';

const Map = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={19} viewBox="0 0 22 19" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
        >
            <path d="M14.59 1.365a1.25 1.25 0 0 0-.93 0l-5.32 2.13c-.299.118-.631.118-.93 0L2.484 1.522a.625.625 0 0 0-.858.583v11.977c0 .512.311.971.786 1.161l5 2c.298.12.63.12.928 0l5.322-2.129c.298-.12.63-.12.928 0l4.928 1.968a.625.625 0 0 0 .858-.583V4.526a1.25 1.25 0 0 0-.786-1.161zM7.875 3.584v13.75M14.125 1.276v13.75" />
        </g>
    </svg>
);
export default Map;
